/* eslint-disable */
import Long from "long";
import * as _m0 from "protobufjs/minimal";
export const protobufPackage = "common";
export var Currency;
(function (Currency) {
    Currency["USD"] = "USD";
    Currency["USD3"] = "USD3";
    Currency["USD5"] = "USD5";
})(Currency || (Currency = {}));
if (_m0.util.Long !== Long) {
    _m0.util.Long = Long;
    _m0.configure();
}
